import React, { useEffect, useState } from "react";
import { FiPlus } from "react-icons/fi";
import { GoPencil } from "react-icons/go";
import AdminLayout from "../../layout/AdminLayout";
import { getCurrentUser } from "../../../api/user.api";
import { baseURL } from "../../../api/api";
import AddCompany from "./AddCompany";
import { getAllCompanies } from "../../../api/companies.api";
import { RotatingLines } from "react-loader-spinner";

function Companies() {
  const [addCompanyOpen, setAddCompanyOpen] = useState(false);
  const [companiesData, setCompaniesData] = useState([]);
  const [editCompanyId, setEditCompanyId] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCompanies = () => {
    setLoading(true);
    getCurrentUser()
      .then((res) => {
        getAllCompanies()
          .then((res) => {
            setLoading(false);
            setCompaniesData(res?.data?.companies);
          })
          .catch((error) => {
            setLoading(false);
            console.error("Error fetching data:", error);
          });
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  const truncateAddress = (address) => {
    if (!address) return "";
    return address.length > 50 ? `${address.substring(0, 50)}...` : address;
  };

  return (
    <>
      <AddCompany
        open={addCompanyOpen}
        setOpen={setAddCompanyOpen}
        fetchCompanies={fetchCompanies}
        editCompanyId={editCompanyId}
      />
      <AdminLayout title="Advertisers">
        <div className="px-1 sm:px-3 lg:px-8">
          <div className="mb-5 flex items-center justify-end sticky top-16 bg-slate-50 py-3 z-10 px-2">
            <button
              onClick={() => {
                setAddCompanyOpen(true);
                setEditCompanyId(null);
              }}
              className="flex items-center justify-center rounded-md bg-yellowColor px-3 py-2.5 text-base font-semibold text-gray-700 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellowColor"
            >
              <FiPlus className="text-lg text-gray-700" />
              Add Advertiser
            </button>
          </div>
          {loading ? (
            <div className="flex justify-center items-center h-64">
              <RotatingLines
                strokeColor="black"
                strokeWidth="5"
                animationDuration="0.75"
                width="96"
                visible={true}
              />
            </div>
          ) : (
            <div className="mt-5 flow-root">
              {companiesData.length === 0 ? (
                <div className="text-center font-bold text-gray-600 text-xl my-4">
                  No Companies added.
                </div>
              ) : (
                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 rounded-lg">
                      <table className="min-w-full divide-y divide-gray-300">
                        <thead className="bg-gray-50">
                          <tr>
                            <th
                              scope="col"
                              className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                            >
                              Name
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                            >
                              Email
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                            >
                              Phone
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                            >
                              Address
                            </th>
                            <th
                              scope="col"
                              className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                            >
                              <span className="sr-only">Actions</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 bg-white">
                          {companiesData.map((company) => (
                            <tr key={company._id}>
                              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6">
                                <div className="flex items-center">
                                  {company.logo && (
                                    <div className="h-10 w-10 flex-shrink-0">
                                      <img
                                        className="h-10 w-10 rounded-full object-cover"
                                        src={`${baseURL}/s3/images/${company.logo}`}
                                        alt="Company logo"
                                      />
                                    </div>
                                  )}
                                  <div className="ml-4">
                                    <div className="font-medium text-gray-900">
                                      {company.name}
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                {company.email}
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                {company.phone}
                              </td>
                              <td className="px-3 py-4 text-sm text-gray-500">
                                {truncateAddress(company.address)}
                              </td>
                              <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                <button
                                  onClick={() => {
                                    setAddCompanyOpen(true);
                                    setEditCompanyId(company._id);
                                  }}
                                  className="text-indigo-600 hover:text-indigo-900"
                                >
                                  <GoPencil className="h-5 w-5" />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </AdminLayout>
    </>
  );
}

export default Companies;
